import type { InfosecStorageUnit } from '../../pages/computers-page/infosec-procedure/infosecStorageUnit';

export const mappedComputers = (computers): InfosecStorageUnit[] =>
  computers
    .filter((item) => {
      return !item.deleted && item.unitType === 'computer';
    })
    .map((item) => {
      let computerType = '';
      if (item.type !== '' && item.type !== 'UNDEFINED') {
        computerType = item.type;
      }
      return {
        uuid: item.uuid,
        name: item.name || item.type || 'Datamaskin',
        unitType: 'computers',
        computerType: computerType,
        application: '',
        partnerUuid: '',
        networkUuid: item.networkUuid ?? '',
      };
    });
